export const CURRENT_CLIENT_MANAGER_ERRORS = {
    changeView: 'AccountChangeError',
};
